import * as tslib_1 from "tslib";
import * as React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppSettings from './AppSettings';
import AppHeader from './AppHeader';
import { Login } from 'src/pages/login/Login';
import { Notifications } from './Notifications';
import { routeCollection } from 'src/routes';
var Layout = /** @class */ (function (_super) {
    tslib_1.__extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoginDialogOpen: false
        };
        _this.onVerify = function () {
            if (!_this.props.userStore.isAuthenticated) {
                _this.setState({ isLoginDialogOpen: true });
            }
        };
        _this.handleLoginOpen = function () {
            _this.setState({ isLoginDialogOpen: true });
        };
        _this.handleLoginClose = function () {
            _this.setState({ isLoginDialogOpen: false });
        };
        _this.handleLogout = function () {
            _this.props.userStore.logout();
        };
        _this.props.userStore.verified.subscribe(_this.onVerify);
        return _this;
    }
    Layout.prototype.render = function () {
        var isLoginDialogOpen = this.state.isLoginDialogOpen;
        var userStore = this.props.userStore;
        var projectStore = this.props.projectStore;
        var isAuthenticated = userStore.isAuthenticated;
        var routes = isAuthenticated
            ? routeCollection.getEnabledRoutes(userStore, projectStore).map(function (i) { return React.createElement(Route, tslib_1.__assign({ key: i.path }, i)); })
            : null;
        return (React.createElement(BrowserRouter, { basename: process.env.PUBLIC_URL || '' },
            React.createElement(MuiThemeProvider, null,
                React.createElement(React.Fragment, null,
                    React.createElement(AppSettings, null),
                    React.createElement(AppHeader, { onLogin: this.handleLoginOpen, onLogout: this.handleLogout }),
                    routes,
                    React.createElement(Login, { isOpen: isLoginDialogOpen, onClose: this.handleLoginClose }),
                    React.createElement(Notifications, null)))));
    };
    Layout = tslib_1.__decorate([
        inject('userStore', 'projectStore'),
        observer
    ], Layout);
    return Layout;
}(React.Component));
export { Layout };



//////////////////
// WEBPACK FOOTER
// ./src/layout/Layout.tsx
// module id = 378
// module chunks = 0